import { createEnvelopeSource } from './create-envelope-source';
import { withCampaignWindows } from './create-campaign-source';
import type { CampaignSourceConfig } from './create-campaign-source';
import { ROAD_TO_REWARDS_CAMPAIGN_ID } from './road-to-rewards-campaign';

type VisitsLedgerMetric =
    | 'visitsReceived'
    | 'visitsCounted'
    | 'rejectedUnderMinSpend'
    | 'rejectedGapTooShort'
    | 'rejectedDailyCap'
    | 'revenueReceived'
    | 'revenueCounted';

/** Whole-campaign scope: every LIFT row Six12 sent in the window, on any
 * phone, enrolled or not. Unlike `campaign-visits`/`campaign-purchases` (both
 * `-member` endpoints), this source shares no denominator with the
 * enrolled-member cards. All seven metrics are plain scalars: no ratio has a
 * meaningful denominator at this scope. */
const config: CampaignSourceConfig<VisitsLedgerMetric> = {
    label: 'Campaign visits ledger',
    endpoint: 'analytics/campaign-visits-ledger',
    metrics: [
        { id: 'visitsReceived', label: 'Visits received', type: 'scalar' },
        { id: 'visitsCounted', label: 'Counted as visits', type: 'scalar' },
        {
            id: 'rejectedUnderMinSpend',
            label: 'Rejected: under $5',
            type: 'scalar',
        },
        {
            id: 'rejectedGapTooShort',
            label: 'Rejected: within 3h',
            type: 'scalar',
        },
        {
            id: 'rejectedDailyCap',
            label: 'Rejected: daily cap',
            type: 'scalar',
        },
        {
            id: 'revenueReceived',
            label: 'Revenue received',
            type: 'scalar',
            isCurrency: true,
        },
        {
            id: 'revenueCounted',
            label: 'Revenue counted',
            type: 'scalar',
            isCurrency: true,
        },
    ],
    forms: ['trio'],
    regionGrain: 'province',
    staticParams: { campaignId: ROAD_TO_REWARDS_CAMPAIGN_ID },
};

export const campaignVisitsLedgerSource = withCampaignWindows(
    createEnvelopeSource(config),
    config
);
